export default __webpack_public_path__ + "static/media/mint.0aaa7a52.mp4";